__turbopack_context__.v({
  "chatbotsTable": "ChatbotsTable-module__355DXq__chatbotsTable",
  "conversationsColumnLabel": "ChatbotsTable-module__355DXq__conversationsColumnLabel",
  "emptyState": "ChatbotsTable-module__355DXq__emptyState",
  "lastModifiedColumn": "ChatbotsTable-module__355DXq__lastModifiedColumn",
  "locationColumn": "ChatbotsTable-module__355DXq__locationColumn",
  "modelColumn": "ChatbotsTable-module__355DXq__modelColumn",
  "recentConversationsColumn": "ChatbotsTable-module__355DXq__recentConversationsColumn",
  "upgradeBadge": "ChatbotsTable-module__355DXq__upgradeBadge",
});
